module.exports = __webpack_public_path__ + "static/assets/329ee32bc62695d483caf1e427b5a3f1.svg";